/**
 * Re-apply cookie banner layout after Shopify injects its own positioning styles.
 * Syncs body.cookie-banner-open so the backdrop is removed when the banner closes.
 */
(function () {
  const STYLE_ID = 'mr-barbershop-cookie-banner-fix';
  const BODY_CLASS = 'cookie-banner-open';

  const POSITION_RULES = `
    #shopify-pc__banner.shopify-pc__banner__dialog {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      right: auto !important;
      bottom: auto !important;
      transform: translate(-50%, -50%) !important;
      width: min(22rem, calc(100vw - 2rem)) !important;
      max-width: 22rem !important;
      min-width: 0 !important;
      height: auto !important;
      z-index: 999999 !important;
    }

    #shopify-pc__banner .shopify-pc__banner__wrapper {
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      position: static !important;
      inset: auto !important;
      width: 100% !important;
      height: auto !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      transform: none !important;
    }

    #shopify-pc__banner .shopify-pc__banner__btns {
      display: flex !important;
      flex-direction: column !important;
      min-width: 0 !important;
      width: 100% !important;
      margin: 0 !important;
    }

    #shopify-pc__banner .shopify-pc__banner__btns button {
      margin: 0 !important;
      width: 100% !important;
    }

    #shopify-pc__banner .shopify-pc__banner__body {
      width: 100% !important;
      margin: 0 0 1rem !important;
    }
  `;

  function isBannerVisible(dialog) {
    if (!dialog || !document.body.contains(dialog)) return false;
    if (dialog.hidden) return false;
    if (dialog.getAttribute('aria-hidden') === 'true') return false;

    const style = window.getComputedStyle(dialog);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;

    const rect = dialog.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function syncBodyState() {
    const dialog = document.getElementById('shopify-pc__banner');
    const visible = isBannerVisible(dialog);

    document.body.classList.toggle(BODY_CLASS, visible);

    if (!visible) {
      document.body.style.removeProperty('overflow');
    }
  }

  function injectOverrideStyles() {
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = POSITION_RULES;
    }

    const shopifyStyles = document.getElementById('shopify-pc__banner__styles');

    if (shopifyStyles && shopifyStyles.nextSibling !== style) {
      shopifyStyles.insertAdjacentElement('afterend', style);
      return;
    }

    if (!style.parentElement) {
      document.head.appendChild(style);
    }
  }

  function fixBannerLayout() {
    const dialog = document.getElementById('shopify-pc__banner');
    if (!dialog) {
      syncBodyState();
      return;
    }

    dialog.style.setProperty('position', 'fixed', 'important');
    dialog.style.setProperty('top', '50%', 'important');
    dialog.style.setProperty('left', '50%', 'important');
    dialog.style.setProperty('right', 'auto', 'important');
    dialog.style.setProperty('bottom', 'auto', 'important');
    dialog.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
    dialog.style.setProperty('width', 'min(22rem, calc(100vw - 2rem))', 'important');
    dialog.style.setProperty('max-width', '22rem', 'important');
    dialog.style.setProperty('min-width', '0', 'important');
    dialog.style.setProperty('height', 'auto', 'important');
    dialog.style.setProperty('z-index', '999999', 'important');

    const wrapper = dialog.querySelector('.shopify-pc__banner__wrapper');
    if (wrapper) {
      wrapper.style.setProperty('display', 'flex', 'important');
      wrapper.style.setProperty('flex-direction', 'column', 'important');
      wrapper.style.setProperty('position', 'static', 'important');
      wrapper.style.setProperty('width', '100%', 'important');
      wrapper.style.setProperty('height', 'auto', 'important');
      wrapper.style.setProperty('min-width', '0', 'important');
      wrapper.style.setProperty('background', 'transparent', 'important');
      wrapper.style.setProperty('transform', 'none', 'important');
    }

    const buttons = dialog.querySelector('.shopify-pc__banner__btns');
    if (buttons) {
      buttons.style.setProperty('display', 'flex', 'important');
      buttons.style.setProperty('flex-direction', 'column', 'important');
      buttons.style.setProperty('min-width', '0', 'important');
      buttons.style.setProperty('width', '100%', 'important');
    }

    dialog.querySelectorAll('.shopify-pc__banner__btns button').forEach((button) => {
      button.style.setProperty('margin', '0', 'important');
      button.style.setProperty('width', '100%', 'important');
    });

    syncBodyState();
  }

  function applyFixes() {
    injectOverrideStyles();
    fixBannerLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }

  const observer = new MutationObserver(() => {
    applyFixes();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'hidden', 'aria-hidden', 'class'],
  });
})();
